<script type="application/ld+json">
	{     
		"@context": "http://schema.org",
		"@type": "BreadcrumbList",
		"itemListElement": [
		{
		  "@type": "ListItem",
		  "position": 1,
		  "item": {
		    "@id": "https://www.protectt.ai/",
		    "name": "Home"
		  }
		},{
		  "@type": "ListItem",
		  "position": 2,
		  "item": {
		    "@id": "https://www.protectt.ai/realtime-protectt",
		    "name": "RealTime Protectt"
		  }
		}		]
	}
	</script>
<!-- Breadcrumbs -->
<div class="breadcrumbs">
  <div class="container">
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <ul class="breadcrumbsul">
          <li><a href="#">Home</a></li>
          <li>></li>
          <li>RealTime Protectt</li>
        </ul>
      </div>
    </div>
  </div>
</div>

<!-- Start Introduction -->
<div
  style="background: linear-gradient(0deg, rgba(0, 0, 0, 0.0), rgba(0, 0, 0, 0.0)),url('assets/images/header/header-1.webp'); background-position: right; background-size: cover;"
  class="section-agency-benefit section-pt section-pb-60 d-none d-md-block" (window:resize)="onResize($event)">
  <div class="container subbanner">
    <div class="row align-items-center">
      <div class="col-lg-8 col-md-8 col-xl-8">
        <div class="d-none d-sm-block" *ngIf="innerWidth > 768">
          <h1 id="bnr-heading">{{heading}}</h1>
          <h2 id="bnr-subheading">{{subheading}}</h2>
          <a class="btn-rectangle btn-transparent btn" data-toggle="modal" data-target="#modalContactForm">Request A
            Demo</a>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- Banner For Mobile -->

<div
  style="background: linear-gradient(0deg, rgba(0, 0, 0, 0.0), rgba(0, 0, 0, 0.0)),url('assets/images/header/header-mobile.webp'); background-position: top; background-size: cover;"
  class="section-agency-benefit section-pt section-pb-60 d-block d-md-none">
  <div class="container subbanner">
    <div class="row align-items-center">
      <div class="col-lg-12">
        <div class="mt-50">
          <!-- header background -->
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Banner Heading For Mobile -->

<div class="container d-block d-md-none subbanner" (window:resize)="onResize($event)">
  <div class="row">
    <div class="col-12">
      <div class="mt-15 mb-15 text-center" *ngIf="innerWidth <= 768">
        <h1 id="bnr-heading">{{heading}}</h1>
        <h4 id="bnr-subheading">{{subheading}}</h4>
        <a class="btn-rectangle btn-transparent btn" data-toggle="modal" data-target="#modalContactForm">Request A
          Demo</a>
        <a class="btn-rectangle btn-transparent btn ml-2" href="tel:8850106650">
          <!-- <i class="fa fa-phone" aria-hidden="true"></i>  -->
          <img src="assets/images/app-protectt/phone_icon.png" alt="Phone">
          +91-8850106650
        </a>
      </div>
    </div>
  </div>
</div>



<!-- End Introduction -->

<!-- <div class="section-pt bg-gray">
  <div class="container text-center">
  <h3 style="margin-bottom: 0;">Ahead of time Fraud and Risk & Management solution for Realtime payments powered by AI/ML
  </h3>
  </div>
  <div class="text-center">
    <pre></pre>
    <a class="btn-circle btn-transparent btn" href="mailto:sales@protectt.ai">Get In Touch</a>
  </div>
</div> -->

<!-- Start Agency Benefits Area -->
<div class="section-agency-benefit bg-gray">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-lg-6 ">
        <div class="agency-thumb">
          <div class="thumb">
            <img src="assets/images/real-time-protectt/real-time-protection1.webp" class="og_image_url"
              alt="Digital Transformation & Real Time Payments">
            <!-- <div class="play-btn">
                      <a class="video-popup" href="https://www.youtube.com/watch?v=G_G8SdXktHg"><i
                              class="fa fa-play"></i></a>
                  </div> -->
          </div>
        </div>
      </div>
      <div class="col-lg-6 ">
        <div class="agency-benefits">
          <div class="content">
            <div>
              <h2>Incorporate trust to the RealTime payments</h2>
            </div>
            <p>Global economy is witnessing unprecedented digital transformation and adoption of real time payments
              imitated from Mobil devices are outnumbering traditional payment channels. The revolutionary payment rail
              - Unified Payment Interface (UPI) of India has set raised the bar for the real time payments across the
              globe. The faster the payment execution time comes with bigger challenge of trailing the instructions in
              the prism of suspicion. The fraudsters takes advantage of traditional system limitations and compromise
              the targeted customers. The consequence of fraudulent transaction to financial institutions includes</p>
            <ul id="bullets">
              <li>Reputation and financial Loss for the bank</li>
              <li>Regulatory compliance</li>
            </ul>
            <p>We at Protectt.ai analysed the possible modus operandi around the RealTime payments with case
              studies and cracked the codes of patterns. The risk score engine consists real life aspects involved in
              the transactions and powered by AI-ML engine concludes the nature of transactions ahead of time.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- End Agency Benefits Area -->


<!-- Start Products Style-->
<div class="section-service section-pt">
  <div class="container">
    <div class="row">
      <div class="col-lg-12">
        <div class="section-title text-center">
          <span style="color: #da2b27;">A one stop FRM Solution</span>
          <h2>Protect your Mobile banking Apps and UPI</h2>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="agency-thumb">
        <div class="thumb">
          <img src="assets/images/real-time-protectt/services1.webp"
            alt="Secure you Digital Payments from Mobile Security App">
        </div>
      </div>
    </div>
  </div>
</div>
<!-- End Products Style-->

<section class="wrapper-card">
  <div class="container-fostrap py-4">
    <div class="content">
      <div class="container appprotecttcard">
        <div class="row">
          <div class="col-md-4">
            <div class="card mt-4">
              <div class="card-body">
                <img alt="Identity Theft" title="Identity Theft" class="finbyz-icon img-responsive"
                        src="assets/images/real-time-protectt/identity_theft.webp">
                <h6 class="card-title font-weight-bold">Identity theft - Creating fraudulent VPA / identifier</h6>
              </div>
            </div>
          </div>

          <div class="col-md-4">
            <div class="card mt-4">
              <div class="card-body">
                <img alt="Impesonating Merchant" title="Impesonating Merchant" class="finbyz-icon img-responsive"
                        src="assets/images/real-time-protectt/impersonating.webp">
                <h6 class="card-title font-weight-bold">Impersonating merchant transactions for pull request</h6>
              </div>
            </div>
          </div>

          <div class="col-md-4">
            <div class="card mt-4">
              <div class="card-body">
                <img alt="Customer Device" title="Customer Device" class="finbyz-icon img-responsive"
                        src="assets/images/real-time-protectt/customer.webp">
                <h6 class="card-title font-weight-bold">Customer Device details hijacking</h6>
              </div>
            </div>
          </div>

          <div class="col-md-2 mt-4"></div>

          <div class="col-md-4">
            <div class="card mt-4">
              <div class="card-body">
                <img alt="Social Engineering" title="Social Engineering" class="finbyz-icon img-responsive"
                        src="assets/images/real-time-protectt/social_engineering.webp">
                <h6 class="card-title font-weight-bold">Social engineering targeted to Non-Tech savvy customers</h6>
              </div>
            </div>
          </div>

          <div class="col-md-4 mt-4">
            <div class="card">
              <div class="card-body">
                <img alt="Compromising Technical Loopholes" title="Compromising Technical Loopholes" class="finbyz-icon img-responsive"
                        src="assets/images/real-time-protectt/compromising.webp">
                <h6 class="card-title font-weight-bold">Compromising technical loopholes through weaker entity on the
                  eco system</h6>
              </div>
            </div>
          </div>

          <div class="col-md-2 mt-4"></div>

        </div>
      </div>
    </div>
  </div>
</section>

<!-- Start Other Features -->
<div class="section-agency-benefit">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-lg-12">
        <div class="section-title text-center">
          <h2>RealTime Protectt Adds trust to the transaction </h2>
        </div>
      </div>
    </div>

    <div id="accordion">
      <div class="card">
        <div class="card-header" id="headingOne">
          <h5 class="mb-0 cardheading">
            <button class="btn-link border-0 w-95 text-left" data-toggle="collapse" data-target="#collapseOne"
              aria-expanded="true" aria-controls="collapseOne">
              Extend your defense
            </button>
            <span class="float-right on">-</span>
            <span class="float-right off">+</span>
          </h5>
        </div>

        <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordion">
          <div class="card-body">
            <p>We offer financial institutions a
              comprehensive fraud prevention platform
              that delivers broad visibility across the threat
              landscape.</p>
            <ol>
              <li>Analyse transaction point of origination
                and characteristics</li>
              <li>Accurate mobile defence data for fraud symptoms</li>
              <li>Eliminations of known risks and patterns</li>
              <li>Alert people, process and systems for remedial </li>
            </ol>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-header" id="headingTwo">
          <h5 class="mb-0 cardheading">
            <button class="btn-link collapsed border-0 w-95 text-left" data-toggle="collapse" data-target="#collapseTwo"
              aria-expanded="false" aria-controls="collapseTwo">
              Expand Data Analysis to all the Touch Points
            </button>
            <span class="float-right on">-</span>
            <span class="float-right off">+</span>
          </h5>
        </div>
        <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordion">
          <div class="card-body">
            <p>Our best-in-class AI engine is capable of pin pointing the possible attack before execution of the
              financial
              instruction.</p>
            <ol>
              <li>Correlate channels data and analyse</li>
              <li>Historical data-based analysis on customer merchant transactions</li>
              <li>Analyse the Beneficiary account patters</li>
            </ol>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-header" id="headingThree">
          <h5 class="mb-0 cardheading">
            <button class="btn-link collapsed border-0 w-95 text-left" data-toggle="collapse"
              data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
              Exclude Legitimate Transactions
            </button>
            <span class="float-right on">-</span>
            <span class="float-right off">+</span>
          </h5>
        </div>
        <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordion">
          <div class="card-body">
            <p>The turnaround time is the key to real time payments and any delay to the transaction execution will lead
              to
              customer dissatisfaction. </p>
            <ol>
              <li>Lowest False positive</li>
              <li>No performance bottle necks to genuine transactions.</li>
              <li>High availability of service.</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>
<!-- End Other Features -->

<div class="modal fade" id="modalContactForm" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
  aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div style="background: #163e6f" class="p-2">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="onReset()" #closebutton>
          <span style="color: #fff" aria-hidden="true">&times;</span>
        </button>
        <h4 style="color: #fff" class="modal-title w-100 font-weight-bold">
          Contact Us
        </h4>
        <h6 style="color: #fff">Discuss your cyber security needs</h6>
      </div>
      <div style="display: block" class="modal-header text-center">
        <p class="formparagraph1">Protectt.ai cherish your excellent decision Talk to Protectt.ai
          to
          learn more about how we can secure your mobile app and its data, by filling out the form below.
          For
          product support, please visit our contact sales page.
        </p>
      </div>
      <div class="modal-body mx-3">
        <form [formGroup]="demoForm" class="contactusform">
          <div class="row">

            <div class="md-form mb-20 col-md-4">
              <label class="mb-0" data-error="wrong" data-success="right" for="form34">Name*</label>
              <input type="text" placeholder="Enter Your Name" id="form34" class="form-control validate input"
                formControlName="name" name="name"
                [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.name.errors }">
              <div *ngIf="demoSubmitted && getDemoForm.name.errors" class="invalid-feedback">
                <div *ngIf="getDemoForm.name.errors.required">* This field is required</div>
                <div *ngIf="getDemoForm.name.errors.pattern">* Please enter valid name</div>
                <div *ngIf="getDemoForm.name.errors.maxlength">* Please enter valid name</div>
              </div>
            </div>

            <div class="md-form mb-20 col-md-4">
              <label class="mb-0" data-error="wrong" data-success="right" for="form34">Email*</label>
              <input type="email" placeholder="Enter Your Email " formControlName="email" class="form-control input"
                id="email" name="email" [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.email.errors }">
              <div *ngIf="demoSubmitted && getDemoForm.email.errors" class="invalid-feedback">
                <div *ngIf="getDemoForm.email.errors.required">* This field is required</div>
                <div *ngIf="getDemoForm.email.errors.pattern">* Email must be valid</div>
                <div *ngIf="getDemoForm.email.errors.isValidEmail">* Plaese enter business email</div>
              </div>
            </div>

            <div class="md-form mb-20 col-md-4">
              <label class="mb-0" data-error="wrong" data-success="right" for="form34">Phone
                Number*</label>
              <input type="text" placeholder="Enter Your Phone Number" id="form34" class="form-control validate input"
                formControlName="contactnumber" name="contactnumber"
                [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.contactnumber.errors }">
              <div *ngIf="demoSubmitted && getDemoForm.contactnumber.errors" class="invalid-feedback">
                <div *ngIf="getDemoForm.contactnumber.errors.required">* This field is required
                </div>
                <div *ngIf="getDemoForm.contactnumber.errors.pattern">* Please, Enter 10 digit
                  Mobile
                  Number.
                </div>
              </div>
            </div>
          </div>


          <div class="row">
            <div class="md-form mb-20 col-md-6">
              <label class="mb-0" data-error="wrong" data-success="right" for="form34">Company*</label>
              <input type="text" placeholder="Enter Your Company Name" id="form34" class="form-control validate input"
                formControlName="company_name" name="company_name"
                [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.company_name.errors }">
              <div *ngIf="demoSubmitted && getDemoForm.company_name.errors" class="invalid-feedback">
                <div *ngIf="getDemoForm.company_name.errors.required">* This field is required</div>
              </div>
            </div>

            <div class="md-form mb-20 col-md-6">
              <label class="mb-0" data-error="wrong" data-success="right" for="form34">Designation*</label>
              <input type="text" placeholder="Enter Your Designation" id="form34" class="form-control validate input"
                formControlName="designation" name="designation"
                [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.designation.errors }">
              <div *ngIf="demoSubmitted && getDemoForm.designation.errors" class="invalid-feedback">
                <div *ngIf="getDemoForm.designation.errors.required">* This field is required</div>
                <div *ngIf="getDemoForm.designation.errors.maxlength">* Please enter valid name</div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="md-form mb-20 col-md-6">
              <label class="mb-0" data-error="wrong" data-success="right" for="form34">Preferred Time
                Slot
                1*</label>
              <input type="datetime-local" id="form34" class="form-control validate input" formControlName="time_slot1"
                name="time_slot1" [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.time_slot1.errors }">
              <div *ngIf="demoSubmitted && getDemoForm.time_slot1.errors" class="invalid-feedback">
                <div *ngIf="getDemoForm.time_slot1.errors.required">* This field is required</div>
              </div>
            </div>
            <div class="md-form mb-20 col-md-6">
              <label class="mb-0" data-error="wrong" data-success="right" for="form34">Preferred Time
                Slot
                2*</label>
              <input type="datetime-local" id="form34" class="form-control validate input" formControlName="time_slot2"
                name="time_slot2" [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.time_slot2.errors }">
              <div *ngIf="demoSubmitted && getDemoForm.time_slot2.errors" class="invalid-feedback">
                <div *ngIf="getDemoForm.time_slot2.errors.required">* This field is required</div>
              </div>
            </div>
          </div>
          <div class="md-form">
            <label class="mb-0" data-error="wrong" data-success="right" for="form8">How can we help
              you?</label>
            <textarea maxlength="250" placeholder="Must be under 250 characters." type="text" id="form8"
              class="md-textarea form-control" formControlName="message" name="message" rows="2">
            </textarea>
          </div>
          <div class="modal-footer d-flex justify-content-center">
            <button class="btn btn-unique" id="closeModal" (click)="submitDemoForm()">Send</button>
            <button type="button" class="btn btn-secondary" data-dismiss="modal" aria-label="Close" (click)="onReset()">
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>